import {
  FormOutlined,
  GlobalOutlined,
  OpenAIOutlined,
  FileTextOutlined,
  FolderOutlined,
  UserOutlined,
  AppstoreOutlined,
  WalletOutlined,
  CalculatorOutlined,
  PercentageOutlined,
  SwapOutlined,
  GoldOutlined,
  HomeOutlined,
  BuildOutlined,
  FileAddOutlined,
  FileDoneOutlined,
  CheckCircleOutlined,
  ApiOutlined,
  SettingOutlined,
  SoundOutlined,
  ToolOutlined,
  AuditOutlined,
  BankOutlined,
  LineChartOutlined,
  SafetyOutlined,
  RobotOutlined,
} from '@ant-design/icons';

export const ICON_MAPPER: { [key: string]: JSX.Element } = {
  search: <OpenAIOutlined />,
  agents: <RobotOutlined />,
  zoom: <GlobalOutlined />,
  document: <FileTextOutlined />,
  form: <FormOutlined />,
  folder: <FolderOutlined />,
  user: <UserOutlined />,
  dashboard: <AppstoreOutlined />,
  wallet: <WalletOutlined />,
  calc: <CalculatorOutlined />,
  percent: <PercentageOutlined />,
  swap: <SwapOutlined />,
  utils: <GoldOutlined />,
  home: <HomeOutlined />,
  building: <BuildOutlined />,
  fileAdd: <FileAddOutlined />,
  fileDone: <FileDoneOutlined />,
  check: <CheckCircleOutlined />,
  api: <ApiOutlined />,
  app: <AppstoreOutlined />,
  tool: <ToolOutlined />,
  setting: <SettingOutlined />,
  sound: <SoundOutlined />,
  tax: <AuditOutlined />,
  mortgage: <BankOutlined />,
  data: <LineChartOutlined />,
  security: <SafetyOutlined />,
};
